import styled, { keyframes } from 'styled-components';

const ProductPageSkeleton = () => (
    <ProductWrapper>
        <CarouselWrapper>
            <Thumbnails>
                <ThumbnailsItem />
                <ThumbnailsItem />
                <ThumbnailsItem />
                <ThumbnailsItem />
            </Thumbnails>
            <HeroPhotoWrapper />
        </CarouselWrapper>
        <ProductDetailWrapper>
            <Header />
            <Delivery />
            <Variants />
            <SizePicker />
            <MobilePrice />
            <Button />
        </ProductDetailWrapper>
    </ProductWrapper>
);

const shine = keyframes`
  to {
    background-position: 100% 0;
  }
`;

const AnimatedPlaceholder = styled.div`
    display: block;
    background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.5) 50%,
            rgba(255, 255, 255, 0) 80%
        ),
        lightgray;
    background-repeat: repeat-y;
    background-size: 50px 500px;
    background-position: 0 0;
    animation: ${shine} 1s infinite;
`;

const ProductWrapper = styled.section`
    display: grid;
    grid-template-columns: 64.5% 35.5%;
    max-width: 1440px;
    margin: 0 auto;
    margin-top: 112px;
    min-height: 100vh;

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        width: 100%;
        margin: 0 auto;
        padding: 20px;
    }
`;

const CarouselWrapper = styled.div`
    margin: 20px auto;
    display: flex;
    width: 100%;
    position: relative;
    @media (max-width: 1080px) {
        margin: 0;
    }
`;

const Thumbnails = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 180px;
    overflow-y: auto;
    min-width: 86px;
    margin-top: 40px;
    ::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 1024px) {
        display: none;
    }
`;
const ThumbnailsItem = styled(AnimatedPlaceholder)`
    width: 68px;
    min-width: 68px;
    height: 101px;
    margin-top: 20px;
`;
const HeroPhotoWrapper = styled(AnimatedPlaceholder)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    margin-left: 162px;
    @media (max-width: 1024px) {
        margin-top: 0;
        height: 60vh;
        width: 100%;
        margin: 0;
    }
`;

const ProductDetailWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 40px;
    margin-top: 100px;
    @media (max-width: 1024px) {
        padding: 0;
        margin-top: -90px;
    }
`;

const Header = styled(AnimatedPlaceholder)`
    width: 100%;
    height: 60px;

    @media (max-width: 1024px) {
        width: 90%;
        height: 30px;
        margin-top: 0;
    }
`;

const Delivery = styled(AnimatedPlaceholder)`
    width: 60%;
    height: 30px;
    margin-top: 20px;
    @media (max-width: 1024px) {
        width: 30%;
        height: 45px;
    }
`;

const Variants = styled(AnimatedPlaceholder)`
    width: 100%;
    height: 150px;
    margin-top: 40px;
    @media (max-width: 1024px) {
        display: none;
    }
`;

const SizePicker = styled(AnimatedPlaceholder)`
    width: 100%;
    height: 40px;
    margin-top: 40px;
`;

const Button = styled(AnimatedPlaceholder)`
    width: 80%;
    height: 40px;
    margin-top: 30px;
    @media (max-width: 1024px) {
        position: fixed;
        bottom: 20px;
        right: 30px;
        width: 195px;
    }
`;

const MobilePrice = styled(AnimatedPlaceholder)`
    height: 40px;
    margin-top: 30px;
    position: fixed;
    bottom: 20px;
    left: 30px;
    width: 80px;
    @media (min-width: 1024px) {
        display: none;
    }
`;

export default ProductPageSkeleton;
